import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Route, useHistory, useLocation, Redirect } from "react-router-dom";
import shui_engine from '../../static/logo/logo_2.jpg'
import user_img from '../../static/image/user_img.png'


function HeadLargemodel(){
    return (
        <div style={{ width: '95%', boxShadow: '0px 3px 10px 0px rgba(51,51,51,0.3)', padding: '10px 3%',paddingLeft:'2%', display: 'flex', justifyContent: 'space-between', background: '#4844f3' }}>
            <div style={{ display: 'flex' }}>
                <Link to='/largemodel' style={{ paddingRight: 10 }}>
                    <img src={shui_engine} alt="" style={{ width: 50, height: 50, borderRadius: '50%' }} />
                </Link>
                <Link to='/largemodel' style={{ display: 'flex', alignItems: 'center', }}>
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: 18, color: '#fff', fontWeight: 'bold' }}>动千山智能体</div>
                </Link>
            </div>
            <Link to='/largemodel/mine'>
                <img src={user_img} alt="" style={{ width: 50, height: 50, borderRadius: '50%' }} />
            </Link>
        </div>
    )
}
export default HeadLargemodel;